module.exports = __webpack_public_path__ + "static/fonts/Lato-LightItalic.3d747d8b.ttf";